import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './crowdfunding_campaign_header.less'
import {
  Col,
  Icon,
  Row,
  HeadingText,
  CaptionText,
  Avatar,
} from '@paypalcorp/pp-react'
import { getI18n } from 'client/i18n'
import { daysFromToday } from 'shared/helpers/datetime_helpers'

const i18n = getI18n('components/crowdfunding_campaign_header')

class CrowdFundingCampaignHeader extends React.Component {
  static propTypes = {
    poolName: PropTypes.string.isRequired,
    categoryName: PropTypes.string.isRequired,
    creatorName: PropTypes.string.isRequired,
    profileImage: PropTypes.string.isRequired,
    initials: PropTypes.string.isRequired,
    end_date: PropTypes.string,
    charity: PropTypes.object,
    showDaysRemaining: PropTypes.bool,
  }

  getCharityNameComponent(charity) {
    return (
      <Row styleName="iconCaptionRow">
        <Col lg="auto" md="auto" xs="auto" styleName="iconCaptionContainer">
          <Avatar
            alt="Charity Logo"
            initials={this.props.initials}
            size="xs"
            src={charity.logo_url}
            styleName="avatarImage"
          />
          <CaptionText styleName="headerCaptionText" size="sm">
            {charity.name}
          </CaptionText>
        </Col>
      </Row>
    )
  }

  getOwnerComponent() {
    return (
      <Col lg="auto" md="auto" xs="auto" styleName="iconCaptionContainer">
        <Avatar
          src={this.props.profileImage}
          initials={this.props.initials}
          size="xs"
        />
        <CaptionText styleName="headerCaptionText" size="sm">
          {this.props.creatorName}
        </CaptionText>
      </Col>
    )
  }

  getDaysComponent(end_date) {
    const days = daysFromToday(new Date(end_date))
    return (
      <Col lg="auto" md="auto" xs="auto" styleName="iconCaptionContainer">
        <Icon name="pending" size="xs" />
        <CaptionText styleName="headerCaptionText" size="sm">
          {i18n('end_in', { days: days < 0 ? 0 : days })}
        </CaptionText>
      </Col>
    )
  }

  getCategoryComponent() {
    return (
      <Col lg="auto" md="auto" xs="auto" styleName="iconCaptionContainer">
        <Icon name="activity" size="xs" />
        <CaptionText styleName="headerCaptionText" size="sm">
          {this.props.categoryName}
        </CaptionText>
      </Col>
    )
  }

  render() {
    const { charity, end_date, showDaysRemaining } = this.props
    let component
    if (showDaysRemaining) {
      component = this.getDaysComponent(end_date)
    } else if (charity) {
      component = null
    } else {
      component = this.getOwnerComponent()
    }
    return (
      <React.Fragment>
        <Row>
          <Col>
            <HeadingText as="h1" size="lg">
              {this.props.poolName}
            </HeadingText>
          </Col>
        </Row>
        {charity && this.getCharityNameComponent(charity)}
        <Row styleName="iconCaptionRow">
          {component}
          {this.getCategoryComponent()}
        </Row>
      </React.Fragment>
    )
  }
}

export default cssModules(CrowdFundingCampaignHeader, styles, {
  allowMultiple: true,
})
